import { queryToSearch } from 'app/helpers/routing';
import { setCookie } from '@bibliocommons/utils-browser';

function isSafeRedirectUrl(url) {
  // A leading single slash is a relative path and safe. Reject '//host' — browsers treat
  // protocol-relative URLs as external redirects, so they must go through the protocol check.
  if (url.startsWith('/') && !url.startsWith('//')) return true;
  try {
    const { protocol } = new URL(url);
    return protocol === 'https:' || protocol === 'http:';
  } catch {
    return false;
  }
}

export default function redirectMiddleware() {
  return next => action => {
    const url = action.payload?.forceRedirectURL || action.forceRedirectURL;

    if (url && __CLIENT__) {
      const { method, data } = action;

      if (url.startsWith('/user/login')) {
        const PRE_LOGIN_URL_COOKIE = 'pre_login_url';
        setCookie(PRE_LOGIN_URL_COOKIE, window.location.href, { path: '/' });
      }

      if (method?.toUpperCase() === 'POST' && isSafeRedirectUrl(url)) {
        const form = Object.assign(document.createElement('form'), {
          method: 'post',
          action: url
        });

        Object.entries(data).forEach(([name, value]) => {
          form.appendChild(
            Object.assign(document.createElement('input'), {
              type: 'hidden',
              name,
              value
            })
          );
        });

        document.body.appendChild(form);
        form.submit();
      } else if (isSafeRedirectUrl(url)) {
        window.location.href = `${url}${queryToSearch(data)}`;
      }
      return;
    }

    // eslint-disable-next-line consistent-return
    return next(action);
  };
}
